// src/belediye/services/citizenDeliveryApi.js
// Vatandaşa belge teslimi — personel tarafı API (JWT'li belediyeApi örneğini yeniden kullanır).
import belediyeApi from "./belediyeApi";

const BASE = "/citizen-delivery";

// Saha personelinin TaskFeedback.files dosyaları (iletilebilir) + already_shared bilgisi
export const fetchShareableFiles = (applicationId) =>
  belediyeApi.get(`${BASE}/applications/${applicationId}/shareable-files/`);

// Bu başvuru için mevcut teslim belgeleri (personel görünümü)
export const fetchSharedDocuments = (applicationId) =>
  belediyeApi.get(`${BASE}/applications/${applicationId}/shared-documents/`);

// Saha dosyasını ilet (kopya YOK — referans)
export const forwardSharedDocument = (applicationId, { fileAssetId, title } = {}) =>
  belediyeApi.post(`${BASE}/applications/${applicationId}/shared-documents/`, {
    file_asset_id: fileAssetId,
    ...(title ? { title } : {}),
  });

// Taze dosya yükle (her tür: resim/pdf/belge)
export const uploadSharedDocument = (applicationId, { file, title } = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  if (title) fd.append("title", title);
  return belediyeApi.post(
    `${BASE}/applications/${applicationId}/shared-documents/`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

// Vatandaşa gizle / tekrar göster (yalnız başkan + kapalı başvuru — backend enforce eder)
export const setSharedDocumentVisibility = (sharedDocumentId, visible) =>
  belediyeApi.patch(`${BASE}/shared-documents/${sharedDocumentId}/`, {
    is_visible_to_citizen: !!visible,
  });

// Soft-delete (yalnız başkan + kapalı başvuru — backend enforce eder)
export const removeSharedDocument = (sharedDocumentId) =>
  belediyeApi.delete(`${BASE}/shared-documents/${sharedDocumentId}/`);
